var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1C24",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.833 21.135c0 1.05-.856 2.015-1.906 2.145l-.336.043c-1.777.238-4.28.975-6.294 1.82-.705.292-1.485-.238-1.485-1.008V9.066c0-.4.228-.769.586-.964 1.982-1.072 4.983-2.026 7.02-2.199h.064c1.3 0 2.351 1.05 2.351 2.35v12.882z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58 5.903h-.075c-1.3 0-2.351 1.05-2.351 2.35v12.882c0 1.05.856 2.015 1.907 2.145l.335.043c1.777.238 4.28.975 6.295 1.82.704.292 1.484-.238 1.484-1.008V9.066c0-.411-.217-.769-.574-.964-1.983-1.072-4.984-2.026-7.02-2.199zm3.272 5.482a.811.811 0 1 1 0 1.625H7.415a.811.811 0 1 1 0-1.625h2.437zM7.415 16.26a.811.811 0 1 1 0-1.625h3.25a.811.811 0 1 1 0 1.625h-3.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon-12.ae6bd2d6ffba29b6c9574a6e1df4d802.svg";
export { ForwardRef as ReactComponent };